PrefectureService = ->
  get: ->
    japanese = [
      {name: "北海道", value: "HKD"}
      {name: "青森県", value: "AOM"}
      {name: "岩手県", value: "IWT"}
      {name: "宮城県", value: "MYG"}
      {name: "秋田県", value: "AKT"}
      {name: "山形県", value: "YGT"}
      {name: "福島県", value: "FKS"}
      {name: "茨城県", value: "IBR"}
      {name: "栃木県", value: "TCG"}
      {name: "群馬県", value: "GNM"}
      {name: "埼玉県", value: "SIT"}
      {name: "千葉県", value: "CHB"}
      {name: "東京都", value: "TKY"}
      {name: "神奈川県	", value: "KNG"}
      {name: "新潟県", value: "NGT"}
      {name: "富山県", value: "TYM"}
      {name: "石川県", value: "ISK"}
      {name: "福井県", value: "FKI"}
      {name: "山梨県", value: "YMN"}
      {name: "長野県", value: "NGN"}
      {name: "岐阜県", value: "GIF"}
      {name: "静岡県", value: "SZO"}
      {name: "愛知県", value: "AIC"}
      {name: "三重県", value: "MIE"}
      {name: "滋賀県", value: "SIG"}
      {name: "京都府", value: "KYT"}
      {name: "大阪府", value: "OSK"}
      {name: "兵庫県", value: "HYG"}
      {name: "奈良県", value: "NAR"}
      {name: "和歌山県", value: "WKY"}
      {name: "鳥取県", value: "TTR"}
      {name: "島根県", value: "SMN"}
      {name: "岡山県", value: "OKY"}
      {name: "広島県", value: "HRS"}
      {name: "山口県", value: "YGC"}
      {name: "徳島県", value: "TKS"}
      {name: "香川県", value: "KGW"}
      {name: "愛媛県", value: "EHM"}
      {name: "高知県", value: "KUC"}
      {name: "福岡県", value: "FKO"}
      {name: "佐賀県", value: "SAG"}
      {name: "長崎県", value: "NGS"}
      {name: "熊本県", value: "KMM"}
      {name: "大分県", value: "OIT"}
      {name: "宮崎県", value: "MYZ"}
      {name: "鹿児島県	", value: "KGS"}
      {name: "沖縄県", value: "OKN"}
    ]
    japanese

module.exports = PrefectureService





// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/registration/prefecture-service.coffee